import { BOOKING_STATUS, BOOKING_PAYMENT_STATUS, BOOKING_CONTRACT_STATUS } from "../../../bookings/bookingUtil";

export default class DealContentProvider {

    constructor(storeLanguageModule) {
        this.storeLanguageModule = storeLanguageModule;
    }

    getDealDescriptions = ({status, paymentStatus, contractStatus}) => {
        if(!status){
            return {
                title: "",
                tenantDesc: "",
                ownerDesc: "",
            }
        }
        
        if(status === BOOKING_STATUS.created){
            if(!paymentStatus) return { title: this.storeLanguageModule.deal.pending_booking_payment, tenantDesc: this.storeLanguageModule.deal.landlord_booking_fee_requirement }
            if(paymentStatus === BOOKING_PAYMENT_STATUS.payment_success) return { title: this.storeLanguageModule.deal.pending_confirmation, tenantDesc: this.storeLanguageModule.deal.done, ownerDesc: this.storeLanguageModule.deal.propspect_is_waiting }
            if(paymentStatus === BOOKING_PAYMENT_STATUS.payment_failed) return { title: this.storeLanguageModule.deal.payment_failed, tenantDesc: this.storeLanguageModule.deal.payment_failed_verbose }
            if(paymentStatus === BOOKING_PAYMENT_STATUS.payment_refunded) return { title: this.storeLanguageModule.deal.payment_refunded, tenantDesc: this.storeLanguageModule.deal.payment_refunded_verbose }
            if(paymentStatus === BOOKING_PAYMENT_STATUS.payment_cancelled) return { title: this.storeLanguageModule.deal.payment_cancelled, tenantDesc: this.storeLanguageModule.deal.payment_cancelled_verbose }
        
        }

        // backward compatibility
        if(status === BOOKING_STATUS.pending_owner_confirmation){
            return { title: this.storeLanguageModule.deal.pending_confirmation, tenantDesc: this.storeLanguageModule.deal.done, ownerDesc: this.storeLanguageModule.deal.propspect_is_waiting }
        }

        if(status === BOOKING_STATUS.accepted){
            if(!contractStatus) return { title: this.storeLanguageModule.deal.confirmed, tenantDesc: this.storeLanguageModule.deal.confirmed_verbose, ownerDesc: this.storeLanguageModule.deal.you_confirmed }
            if(contractStatus === BOOKING_CONTRACT_STATUS.contract_signed_tenant) return { title: this.storeLanguageModule.deal.pending_signatures, tenantDesc: this.storeLanguageModule.deal.pending_signatures_landlord, ownerDesc: this.storeLanguageModule.deal.tenant_has_signed }
            if(contractStatus === BOOKING_CONTRACT_STATUS.contract_signed_owner) return { title: this.storeLanguageModule.deal.pending_signatures, tenantDesc: this.storeLanguageModule.deal.landlord_has_signed, ownerDesc: this.storeLanguageModule.deal.pending_signatures_tenant }
            if(contractStatus === BOOKING_CONTRACT_STATUS.contract_signed) return { title: this.storeLanguageModule.deal.contract_signed, tenantDesc: this.storeLanguageModule.deal.contract_signed_verbose, ownerDesc: this.storeLanguageModule.deal.contract_signed_verbose_2 }
            if(contractStatus === BOOKING_CONTRACT_STATUS.contract_cancelled) return { title: this.storeLanguageModule.deal.contract_cancelled, tenantDesc: this.storeLanguageModule.deal.contract_cancelled_verbose, ownerDesc: this.storeLanguageModule.deal.contract_cancelled_verbose }

            if(contractStatus === BOOKING_CONTRACT_STATUS.contract_ended) return { title: this.storeLanguageModule.deal.contract_ended, tenantDesc: "", ownerDesc: "" }
        }

        if(status === BOOKING_STATUS.declined){
            return {
                title: this.storeLanguageModule.deal.declined,
                tenantDesc: this.storeLanguageModule.deal.declined_verbose,
                ownerDesc: this.storeLanguageModule.deal.you_declined
            }
        }

        if(status === BOOKING_STATUS.declinedBySystem){
            return {
                title: this.storeLanguageModule.deal.declined_system,
                tenantDesc: this.storeLanguageModule.deal.declined_system_verbose,
                ownerDesc: this.storeLanguageModule.deal.declined_system_verbose_owner
            }
        }

        if(status === BOOKING_STATUS.cancelled){
            return {
                title: this.storeLanguageModule.deal.cancelled,
                tenantDesc: this.storeLanguageModule.deal.cancelled_verbose,
                ownerDesc: this.storeLanguageModule.deal.tenant_cancelled,
            }
        }
    }
}








// WEBPACK FOOTER //
// ./src/platform/deals/services/DealContentProvider.js